export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9056.1fd6f1b4.jpg";